import { getRequest } from '../apiRequest'
import { BirthdayPerson } from './BirthdayPerson'

type BirthdayResponse = BirthdayPerson[]

export const fetchUpcomingBirthdays = () => {
  return getRequest<BirthdayResponse>('/social-wall/profiles/birthdays/upcoming')
}
